import { Component, Prop, Vue } from 'vue-property-decorator'
import Control from '@/helpers/control'
import fetch from '@/helpers/fetch'

@Component({
	components: {},
})
export default class TableHead extends Vue {
	@Prop() updateMap
	@Prop() fieldHumanNames

	@Prop() elaborators
	@Prop() reviewers
	@Prop() advocates
	@Prop() reportSendingDays

	@Prop() numberOfTrials

	async mounted() {
		this.$store.dispatch('fetchGroupsSimple')
	}

	get groupsAllSimpleList() {
		return this.$store.state.clients.groupsAllSimpleList
	}

	filteredClient: any = null
	filteredFrequency: any = null
	filteredReportType: any = null
	filteredDayOfMonth: any = null
	filteredTrialTotal: any = null
	filteredElaborator: any = null
	filteredReviewer: any = null
	filteredAdvocate: any = null

	getFilters() {
		const filters: any = {}

		if (this.filteredClient) {
			filters.group = this.filteredClient?.id
		}

		const frequencyMap: { [key: string]: string } = {
			Jan: 'reportSendingOnJan',
			Fev: 'reportSendingOnFeb',
			Mar: 'reportSendingOnMar',
			Abr: 'reportSendingOnApr',
			Mai: 'reportSendingOnMay',
			Jun: 'reportSendingOnJun',
			Jul: 'reportSendingOnJul',
			Ago: 'reportSendingOnAug',
			Set: 'reportSendingOnSep',
			Out: 'reportSendingOnOct',
			Nov: 'reportSendingOnNov',
			Dez: 'reportSendingOnDec',
		}

		if (this.filteredFrequency) {
			this.filteredFrequency.forEach((item) => {
				if (item === 'Mensal') {
					for (const key in frequencyMap) {
						filters[frequencyMap[key]] = true
					}
				} else if (item === 'Nunca') {
					for (const key in frequencyMap) {
						filters[frequencyMap[key]] = false
					}
				} else {
					const filterKey = frequencyMap[item]
					if (filterKey) {
						filters[filterKey] = true
					}
				}
			})
		}

		if (this.filteredReportType) {
			filters.reportType = this.filteredReportType
		}

		if (this.filteredDayOfMonth) {
			filters.reportSendingDayOfMonth = this.filteredDayOfMonth
		}

		if (this.filteredElaborator) {
			filters.elaborator = this.filteredElaborator
		}

		if (this.filteredReviewer) {
			filters.reviewer = this.filteredReviewer
		}

		if (this.filteredAdvocate) {
			filters.advocate = this.filteredAdvocate
		}

		return filters
	}

	async onFilterInput() {
		this.$emit('request', this.getFilters(), 1)
	}

	onSearch(allItems, search) {
		if (typeof search !== 'string') return
		const searchArray = search?.split(' ')

		const result = allItems.filter((item) => {
			const name = removeAccents(item.name.toLowerCase())

			return searchArray.every((string) => {
				return name.includes(removeAccents(string.toLowerCase()))
			})
		})

		return result
	}
}

function removeAccents(str) {
	return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
